var map = {
	"./SOBA_101 (1).jpg": 4631,
	"./SOBA_101 (2).jpg": 146,
	"./SOBA_101 (3).jpg": 9325,
	"./SOBA_101 (4).jpg": 2768,
	"./SOBA_101 (5).jpg": 5731,
	"./SOBA_301 (1).jpg": 2097,
	"./SOBA_301 (2).jpg": 9944,
	"./SOBA_301 (3).jpg": 9819,
	"./SOBA_301 (4).jpg": 6570,
	"./SOBA_301 (5).jpg": 5685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1257;